export const PrevArrow = (props) => {
  const { size = 15, onClick, verticalAlign, marginLeft, marginRight, top, color, className = '' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg style={{ verticalAlign }} width={size} height={size} xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 8 12'>
        <path d='M6.5 11L1.5 6L6.5 1' stroke='currentcolor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      </svg>
    </span>
  );
};
